import { render, staticRenderFns } from "./AddPersonEmergencyContactDialog.vue?vue&type=template&id=004c10a8&scoped=true&"
import script from "./AddPersonEmergencyContactDialog.vue?vue&type=script&lang=js&"
export * from "./AddPersonEmergencyContactDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004c10a8",
  null
  
)

export default component.exports